// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
};

export const notifyAnalysisComplete = (filename, score) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return; // user already on page

  const title = 'Analyse terminée - Normascan';
  const body = score != null
    ? `${filename} — Score : ${Math.round(score)}/100`
    : `${filename} — Analyse terminée`;

  const n = new Notification(title, {
    body,
    icon: '/N.svg',
    badge: '/N.svg',
    tag: 'Normascan-analysis',
  });

  n.onclick = () => { window.focus(); n.close(); };
  setTimeout(() => n.close(), 6000);
};

export const updatePageTitle = (hasCompleted) => {
  if (hasCompleted) {
    document.title = '✅ Analyse terminée - Normascan';
  } else {
    document.title = 'Normascan';
  }
};